import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../app/axios";


export const fetchOpenCourses = createAsyncThunk(
  "openCourses/fetchOpenCourses",
  async (contactId, { rejectWithValue }) => {
    try {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.localStorage.getItem("x-auth-token");
      const response = await axios.get(`class/classes/${contactId}`);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to fetch open courses"
      );
    }
  }
);

const openCoursesSlice = createSlice({
  name: "openCourses",
  initialState: {
    openCoursesData: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearOpenCoursesData: (state) => {
      state.openCoursesData = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpenCourses.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.openCoursesData = [];
      })
      .addCase(fetchOpenCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.openCoursesData = action.payload;
        state.error = null;
      })
      .addCase(fetchOpenCourses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch open courses";
        state.openCoursesData = [];
      });
  },
});

export const { clearOpenCoursesData } = openCoursesSlice.actions;
export default openCoursesSlice.reducer;
